export default "__VITE_ASSET__$bSKfb73__"